import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
import { formatearFecha } from "../../../utilidades/formateos";
const apiUrl = process.env.REACT_APP_API_KEY_ADMIN

export const getGasolineras = async (setGasolineras) => {
    await api.get(`${apiUrl}/admin/getGasolineras`).then((res) => {
        setGasolineras(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getAministrativos = async (setAdministradores) => {
    await api.get(`${apiUrl}/admin/permisos/getUsuariosAdministrativos`).then((res) => {
        setAdministradores(res.data)
        console.log("res", res);

    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getTickets = async (data, setTickets) => {
    const dataFiltes = {
        fecha_inicio: formatearFecha(data.desde) ,
        fecha_fin: formatearFecha(data.hasta),
        id_ticket: data.id,
        unidad: data.unidad,
        kilometraje: data.kilometraje,
        folio: data.folio,
        operador: data.operador?.code,
        administrativo: data.administrativo?.code,
        gasolinera: data.gasolinera?.code,
        via_captura: data.viaCaptura?.code
    }
    await api.post(`${apiUrl}/admin/get-ticket`, dataFiltes).then((res) => {

        Swal.close();
        setTickets(res.data)
        console.log("res", res);
    })
        .catch((error) => {
            console.log("error", error);

        })
}

export const addTickets = async (data,onHide,limpiar)=>
{
   await api.post(`${apiUrl}/admin/add-ticket`,data).then((res)=>
    {
        onHide()
        Swal.fire({icon:'success',text:'Subido con éxito'})
        limpiar()
        console.log("res",res);
        
    })
    .catch((error)=>
    {
        Swal.fire({icon:'error',text:error})
        console.log("error",error);
        
    })
}


export const editTickets = async (data,limpiar,onHide)=>
{
    await api.post(`${apiUrl}/admin/edit-ticket`,data).then((res)=>
    {
        Swal.fire({icon:"success",text:"Actualizado con éxito"})
        onHide()
        limpiar()
    })
    .catch((error)=>
    {
        console.log("error",error);
        
    })
}


export const updateEstatusTicket = async (params)=>
{
   await api.post(`${apiUrl}/admin/edit-ticket-estatus`,params).then((res)=>
    {
        
    })
    .catch((error)=>
    {
        console.log("error",error);
        
    })
}
